import { Injectable } from '@angular/core';

export interface MenuI {
  text: string;
  heading?: boolean;
  link?: string;
  icon?: string;
  alert?: string;
  submenu?: any[];
  isRole?: string[];
  isShow?: boolean;
}

@Injectable({providedIn: 'root'})
export class MenuService {

  menuItems: MenuI[] = [];

  constructor() {}

  addMenu(items: MenuI[]) {
    items.forEach((item: MenuI) => {
      this.menuItems.push(item);
    });
  }

  getMenu() {
    return this.menuItems.map((item: MenuI) => {
      let isShow = true;
      return Object.assign({}, item, {isShow: isShow});
    });
  }

}
